<script>
    export default {
        props: [
            'productId',
            'productCode',
            'categoryExternalCode',
            'priceA1',
            'priceA2',
            'priceB1',
            'quantity',
            'minimumQuantityToBeInStock',
            'superGift',
            'initQuantityA1',
            'initQuantityA2',
            'initQuantityB1',
            'initQuantityOm',
            'initQuantityCg',
            'exactOrderQuantityA2',
            'exactOrderQuantityA2Btn',
            'exactOrderQuantityA2Message',
            'maxOrderQuantityB1',
            'maxOrderQuantityB1Btn',
            'maxOrderQuantityB1Message',
            'initMaxOrderQuantityCg',
            'maxOrderQuantityCgBtn',
            'initMaxOrderQuantityCgMessage',
            'initBonusCgLimitReachedMessage',
            'totalMultipleForReward',
            'rewardQuantity',
            'disableOrderA1',
            'disableOrderA2',
            'disableOrderB1',
            'disableOrderCg',
            'disableOrderOm',
        ],
        data() {
            return {
                quantityA1: "",
                quantityA2: "",
                quantityB1: "",
                quantityOm: "",
                quantityCg: "",
                hasQuantity: false,
                maxOrderQuantityCg: 0,
                maxOrderQuantityCgMessage: '',
                bonusCgUsedFromProduct: 0,
            }
        },
        mounted: function(){
            var orderProduct = this;

            orderProduct.quantityA1 = orderProduct.initQuantityA1 ? orderProduct.initQuantityA1 : "";
            orderProduct.quantityA2 = orderProduct.initQuantityA2 ? orderProduct.initQuantityA2 : "";
            orderProduct.quantityB1 = orderProduct.initQuantityB1 ? orderProduct.initQuantityB1 : "";
            orderProduct.quantityOm = orderProduct.initQuantityOm ? orderProduct.initQuantityOm : "";
            orderProduct.quantityCg = orderProduct.initQuantityCg ? orderProduct.initQuantityCg : "";
            orderProduct.maxOrderQuantityCg = orderProduct.initMaxOrderQuantityCg;
            orderProduct.bonusCgUsedFromProduct = orderProduct.quantityCg !== ""
                ? parseFloat(orderProduct.quantityCg * orderProduct.priceA1)
                : 0;

            orderProduct.hasQuantity =  orderProduct.quantityA1 > 0 || orderProduct.quantityA2 > 0 ||
                                        orderProduct.quantityB1 > 0 || orderProduct.quantityOm > 0 ||
                                        orderProduct.quantityCg > 0;
            orderProduct.maxOrderQuantityCgMessage = orderProduct.initMaxOrderQuantityCgMessage;

            Event.$on("summaryUpdated", function(summary){
                let maxQuantity = 0;
                let bonusCg = parseFloat(summary.bonusCg + orderProduct.bonusCgUsedFromProduct);

                if(bonusCg < orderProduct.priceA1) {
                    maxQuantity = 0;
                }else{
                    maxQuantity = Math.floor(parseFloat(bonusCg) / parseFloat(orderProduct.priceA1));
                }

                if(!orderProduct.initMaxOrderQuantityCg || orderProduct.initMaxOrderQuantityCg > maxQuantity) {
                    orderProduct.maxOrderQuantityCg = maxQuantity;
                    orderProduct.maxOrderQuantityCgMessage = orderProduct.initBonusCgLimitReachedMessage;
                }else{
                    orderProduct.maxOrderQuantityCg = orderProduct.initMaxOrderQuantityCg;
                    orderProduct.maxOrderQuantityCgMessage = orderProduct.initMaxOrderQuantityCgMessage + ' ' + Number(orderProduct.maxOrderQuantityCg);
                }
            });

            $(".order__product-quantity input", orderProduct.$el).on("keypress", function(e){
                var quantity = $(this).val();
                var charCode = (e.keyCode ? e.keyCode : e.which);

                if(e.keyCode != 13){
                    var allowedChars="0123456789";

                    if(allowedChars.indexOf(String.fromCharCode(charCode))==-1 ||
                       (String.fromCharCode(charCode) == "0" && quantity == "")){
                        return false;
                    }
                }
            });

            Event.$on("shippingTypeUpdated", function(addToProductCode, removeFromProductCode){
                if (addToProductCode != null && orderProduct.productCode == addToProductCode) {;
                    orderProduct.quantityB1 = 1;
                    Event.$emit('productQuantityChanged', orderProduct);
                } else if (removeFromProductCode != null && orderProduct.productCode == removeFromProductCode) {
                    orderProduct.quantityB1 = null;
                    Event.$emit('productQuantityChanged', orderProduct);
                }
            });
        },
        methods: {
            onQuantityChanged: function(){
                var orderProduct = this;

                if (orderProduct.quantityA1 > 0 && orderProduct.disableOrderA1 == 1) {
                    orderProduct.quantityA1 = null;
                }
                if (orderProduct.quantityA2 > 0 && orderProduct.disableOrderA2 == 1) {
                    orderProduct.quantityA2 = null;
                }
                if (orderProduct.quantityB1 > 0 && orderProduct.disableOrderB1 == 1) {
                    orderProduct.quantityB1 = null;
                }
                if (orderProduct.quantityCg > 0 && orderProduct.disableOrderCg == 1) {
                    orderProduct.quantityCg = null;
                }
                if (orderProduct.quantityOm > 0 && orderProduct.disableOrderOm == 1) {
                    orderProduct.quantityOm = null;
                }

                orderProduct.hasQuantity =  orderProduct.quantityA1 > 0 || orderProduct.quantityA2 > 0 ||
                    orderProduct.quantityB1 > 0 || orderProduct.quantityOm > 0 ||
                    orderProduct.quantityCg > 0;

                if(orderProduct.quantityA2 && orderProduct.exactOrderQuantityA2 &&
                    orderProduct.quantityA2 != orderProduct.exactOrderQuantityA2){
                    Swal.fire({
                        text: orderProduct.exactOrderQuantityA2Message,
                        icon: "warning",
                        buttonsStyling: false,
                        showCancelButton: false,
                        cancelButtonText: orderProduct.exactOrderQuantityA2Btn,
                        confirmButtonText: _t('Ok'),
                        customClass: {
                            confirmButton: 'btn btn-default',
                        }
                    }).then(function (val) {
                            orderProduct.quantityA2 = orderProduct.exactOrderQuantityA2;
                            Event.$emit('productQuantityChanged', orderProduct);
                        });
                }else if(orderProduct.quantityB1 && orderProduct.maxOrderQuantityB1 &&
                            Number(orderProduct.quantityB1) > Number(orderProduct.maxOrderQuantityB1)){
                    Swal.fire({
                        text: orderProduct.maxOrderQuantityB1Message,
                        icon: "warning",
                        buttonsStyling: false,
                        showCancelButton: false,
                        confirmButtonText: _t('Ok'),
                        customClass: {
                            confirmButton: 'btn btn-default',
                        }
                    }).then(function (val) {
                            orderProduct.quantityB1 = orderProduct.maxOrderQuantityB1;
                            Event.$emit('productQuantityChanged', orderProduct);
                        });
                }else if(orderProduct.quantityCg && orderProduct.maxOrderQuantityCg != null &&
                    Number(orderProduct.quantityCg) > Number(orderProduct.maxOrderQuantityCg)){
                    Swal.fire({
                        text: orderProduct.maxOrderQuantityCgMessage,
                        icon: "warning",
                        buttonsStyling: false,
                        showCancelButton: false,
                        cancelButtonText: orderProduct.maxOrderQuantityCgBtn,
                        confirmButtonText: _t('Ok'),
                        customClass: {
                            confirmButton: 'btn btn-default',
                        }
                    }).then(function (val) {
                            orderProduct.quantityCg = orderProduct.maxOrderQuantityCg;
                            orderProduct.bonusCgUsedFromProduct = parseFloat(orderProduct.quantityCg * orderProduct.priceA1);
                            Event.$emit('productQuantityChanged', orderProduct);
                        });
                }else{
                    Event.$emit('productQuantityChanged', orderProduct);
                }

                orderProduct.bonusCgUsedFromProduct = parseFloat(orderProduct.quantityCg * orderProduct.priceA1);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/orders/orderProduct.vue